import { createFileRoute } from '@tanstack/react-router';
import {
  audiencesList,
  creativesList,
  metaDeliveryContract,
  productionsList,
  venuesList,
} from '@/api/resources';
import { warm, warmBackground } from '@/api/loaders';
import { requireCapability } from '@/lib/route-guards';
import { useSetViewShim } from '@/lib/use-set-view';
import { CreateFlow } from '@/screens/create';

export const Route = createFileRoute('/campaigns/new')({
  beforeLoad: requireCapability('campaigns_edit'),
  // The wizard's three pickers, plus venues. Productions AND venues block: the
  // legacy edit state snapshots the selected production on first render and
  // never revisits it, and the venue NAME is resolved onto that snapshot — so a
  // venues list that arrives afterwards leaves "Venue TBD" stuck for the whole
  // session. Venues was already fetched here, just in the background. The
  // remaining two fill their dropdowns behind the first step.
  loader: ({ context }) => {
    warmBackground(
      context.queryClient,
      audiencesList({}),
      creativesList({}),
      metaDeliveryContract(undefined),
    );
    return warm(context.queryClient, productionsList({}), venuesList({}));
  },
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  return <CreateFlow campaign={undefined} audiences={undefined} setView={setView} />;
}
